module.exports = __webpack_public_path__ + "static/transport-cover-b2732ff20f3525a330adc6594d12f9f7.png";